import { FC, PropsWithChildren } from 'react';

import { StyledProps, x } from '@ui-furniture/style';

const sideVariant: {
  left: (props: { isFirst: boolean }) => StyledProps;
  right: (props: { isFirst: boolean }) => StyledProps;
} = {
  left: ({ isFirst }) => ({
    textAlign: 'left',
    alignSelf: 'flex-start',
    bg: 'brand-bright-white',
    color: 'brand-black',
    borderRadius: isFirst ? '8px 8px 8px 2px' : '2px 8px 8px 2px',
  }),
  right: ({ isFirst }) => ({
    textAlign: 'right',
    alignSelf: 'flex-end',
    bg: 'brand-orange',
    color: 'brand-white',
    borderRadius: isFirst ? '8px 8px 2px 8px' : `8px 2px 2px 8px`,
  }),
};

export const MessageBubble: FC<
  PropsWithChildren<{
    side: keyof typeof sideVariant;
    isGroupFirst: boolean;
  }>
> = ({ side, children, isGroupFirst }) => (
  <x.div>
    <x.div
      {...sideVariant[side]({
        isFirst: isGroupFirst,
      })}
      p='md'
      boxShadow='default'
      fontWeight='500'
      display='flex'
      flexDirection='row'
    >
      {children}
    </x.div>
  </x.div>
);
